(function(root){
  'use strict';
  function range(now = new Date(), lang = 'fr', start = 3, end = 4) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now).map(p=>[p.type,p.value]));
    const day = new Date(Date.UTC(+parts.year,+parts.month-1,+parts.day,12));
    let count=0, first, last;
    while(count < end){day.setUTCDate(day.getUTCDate()+1);if(day.getUTCDay()===0)continue;count++;if(count===start)first=new Date(day);if(count===end)last=new Date(day);}
    const format=(date,month)=>{
      const weekday=lang.toLowerCase().startsWith('pt')?['dom.','seg.','ter.','qua.','qui.','sex.','sáb.'][date.getUTCDay()]:new Intl.DateTimeFormat(lang,{timeZone:'UTC',weekday:'short'}).format(date);
      const monthName=new Intl.DateTimeFormat(lang,{timeZone:'UTC',month:'short'}).format(date);
      return weekday+' '+date.getUTCDate()+(month?' '+monthName:'');
    };
    return format(first,first.getUTCMonth()!==last.getUTCMonth()||first.getUTCFullYear()!==last.getUTCFullYear())+' – '+format(last,true);
  }
  function mount(scope = document){
    scope.querySelectorAll('[data-lpc-delivery-estimate]').forEach(node=>{
      const lang=node.ownerDocument.documentElement.lang||'fr';
      const dates=range(new Date(),lang,+node.dataset.startDays,+node.dataset.endDays);
      node.textContent=node.dataset.deliveryTemplate.replace('[range]',node.dataset.deliverySeparator?dates.replace(' – ',node.dataset.deliverySeparator):dates);
    });
  }
  const api={range,mount};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  else {root.LPCDeliveryEstimate=api;const start=()=>mount();if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();document.addEventListener('visibilitychange',()=>{if(!document.hidden)start();});}
})(typeof window!=='undefined'?window:globalThis);
